import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class UserService {
	constructor(private http: HttpClient) {}

	getUserInfo() {
		return this.http.get('/api/Account/UserInfo');
	}

	confirmUserInformation(params: HttpParams) {
		return this.http.get(`${environment.apiUrl}/api/admin/users/confirm`, { params });
	}

	getListUserCompany(companyId) {
		return this.http.get(`${environment.apiUrl}/api/admin/users/${companyId}/list`);
	}

	getUserById(companyId, userId) {
		return this.http.get(`${environment.apiUrl}/api/admin/users/${companyId}/${userId}`);
	}

	resetUserPassword(userEmail) {
		return this.http.get(`${environment.apiUrl}/api/admin/users/reset/password?userEmail=${userEmail}`);
	}

	addUser(companyId, user) {
		return this.http.post(`${environment.apiUrl}/api/admin/users/${companyId}/create`, user);
	}

	updateUser(companyId, user) {
		return this.http.put(`${environment.apiUrl}/api/admin/users/${companyId}/update`, user);
	}

	deleteUser(companyId, user) {
		return this.http.post(`${environment.apiUrl}/api/admin/users/${companyId}/delete`, user);
	}

	// sendEmailSignUp(email) {
	//   return this.http.get(`${environment.apiUrl}/api/admin/users/register/success?userEmail=${email}`);
	// }
}
